import '../styles/css/bootstrap.min.css'
function Header(){
    return(
        
        <div>
            <nav >
            <ol className="breadcrumb">
                <li className="breadcrumb-item">Home</li>
                <li className="breadcrumb-item active" aria-current="page">Library</li>
            </ol>
            </nav>
           <h2>eAgrimet Web</h2>           
            
        </div>
    )
}

export default Header